module.exports = __webpack_public_path__ + "static/media/landing-hero-img.260543bb.svg";